import { render, staticRenderFns } from "./ListWithIconShimmer.vue?vue&type=template&id=07c6746f&"
import script from "./ListWithIconShimmer.vue?vue&type=script&lang=js&"
export * from "./ListWithIconShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports